import { render, staticRenderFns } from "./BaseTitleCenter.vue?vue&type=template&id=51fd19c9&scoped=true&"
import script from "./BaseTitleCenter.vue?vue&type=script&lang=js&"
export * from "./BaseTitleCenter.vue?vue&type=script&lang=js&"
import style0 from "./BaseTitleCenter.vue?vue&type=style&index=0&id=51fd19c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fd19c9",
  null
  
)

export default component.exports